<template>
  <div>
    <!-- grid toolbar -->
    <v-toolbar flat color="transparent" class="v-toolbar--grid">
      <!-- grid filter -->
      <v-menu
        v-model="filter.dialog"
        :close-on-content-click="false"
        :offset-y="true"
        max-width="300px"
        min-width="300px"
      >
        <template v-slot:activator="{ on }">
          <!-- filter button -->
          <v-btn class="mr-2" large v-on="on" :class="{'teal--text':filter.active}">
            <v-icon>mdi-tune</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-form ref="form" @submit.prevent="getItems">
            <v-card-title>Filter</v-card-title>
            <v-divider />
            <v-card-text>
              <!-- <v-menu
                ref="menu"
                :close-on-content-click="false"
                transition="scroll-y-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filter.data.tanggalPelaporan"
                    label="Tanggal Pelaporan"
                    placeholder="Tanggal Pelaporan"
                    hide-details
                    readonly
                    outlined
                    dense
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="filter.data.tanggalPelaporan" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">Batal</v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(filter.data.tanggalPelaporan)"
                  >OK</v-btn>
                </v-date-picker>
              </v-menu>
              <br />-->
              <v-autocomplete
                class="mb-3"
                v-if="!$acl.check('isSekolah')"
                v-model="filter.data.sekolah"
                :items="list.sekolah.data"
                name="Sekolah"
                label="Sekolah"
                placeholder="Sekolah"
                item-text="Nama"
                item-value="IDSekolah"
                :return-object="false"
                outlined
                hide-details
                multiple
                dense
                hide-selected
                deletable-chips
                chips
              >
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          class="mt-n1"
                          :color="data.item.Tipe=='negeri'?'blue':'green'"
                          x-small
                        >mdi-checkbox-blank-circle</v-icon>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="grey--text text--lighten-1"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.Alamat + ' ' +  data.item.Lokasi + ' ' +  data.item.Provinsi"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-autocomplete
                class="mb-3"
                :items="list.tahun.data"
                item-text="Tahun"
                item-value="Tahun"
                name="Tahun"
                label="Tahun"
                placeholder="Tahun"
                v-model="filter.data.tahun"
                :return-object="false"
                outlined
                chips
                dense
                hide-details
                multiple
              ></v-autocomplete>
              <v-text-field
                class="mb-3"
                v-model="filter.data.nomor"
                hide-details
                outlined
                placeholder="Cari berdasar nomor"
                label="Nomor"
                dense
              ></v-text-field>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-btn text @click="clearFilter">Ulang</v-btn>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="doFilter">Cari</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>

      <!-- grid search -->
      <!-- <v-text-field
        v-model="search.data"
        append-icon="mdi-magnify"
        :label="app.grid.search"
        hide-details
        single-line
        solo
        clearable
      ></v-text-field>-->
      <v-spacer />

      <!-- grid button -->
      <v-btn
        class="ml-2"
        color="cyan white--text"
        large
        to="/laporan/sp2b/baru"
        v-if="$acl.check('isSwasta')"
      >
        <span class="hidden-xs-only" v-text="app.grid.create"></span>
        <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- grid -->
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :loading-text="app.grid.loading"
      :no-data-text="app.grid.noData"
      multi-sort
      class="elevation-1"
    >
      <!-- custom handling -->
      <template v-slot:item.TanggalPelaporan="{ item }">{{item.TanggalPelaporan | date}}</template>
      <template v-slot:item.Sekolah="{ item }">
        <v-list-item three-line class="px-0" dense>
          <v-list-item-content>
            <v-list-item-title>
              <v-icon
                class="mt-n1"
                :color="item.Sekolah.Tipe=='negeri'?'blue':'green'"
                x-small
              >mdi-checkbox-blank-circle</v-icon>
              {{item.Sekolah.Nama}}
              &mdash;
              <span
                class="grey--text text--lighten-1"
              >{{item.Sekolah.Kode}}</span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ item.Sekolah.Alamat}} {{ item.Sekolah.Lokasi}} {{item.Sekolah.Provinsi}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:item.NominalPenerimaan="{ item }">
        <v-chip color="success" small outlined>
          <v-icon small left>mdi-wallet</v-icon>
          {{item.NominalPenerimaan | currency}}
        </v-chip>
      </template>

      <template v-slot:item.NominalBelanja="{ item }">
        <v-chip color="primary" small outlined>
          <v-icon small left>mdi-cart</v-icon>
          {{item.NominalBelanja | currency}}
        </v-chip>
      </template>
      <template v-slot:item.LastUpdatedDate="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
          </template>
          <span>{{$format.updatedDate(item)}}</span>
        </v-tooltip>
      </template>

      <!-- grid header -->
      <template v-slot:header.Actions>
        <div class="float-right">
          <v-btn icon v-if="filter.active" :class="{'mr-4':sort.active}" @click="clearFilter">
            <v-icon>mdi-filter-remove</v-icon>
          </v-btn>
          <v-btn icon v-if="sort.active" @click="clearSort">
            <v-icon>mdi-sort-variant-remove</v-icon>
          </v-btn>
        </div>
      </template>

      <!-- grid actions -->
      <template v-slot:item.Actions="{ item }">
        <div class="float-right">
          <v-btn v-if="!item.ETLID" class="mr-4" icon color="blue" @click="editItem(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" :loading="item.processing">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item v-if="!item.ETLID" @click="deleteItem(item)">
                <v-list-item-icon>
                  <v-icon color="red">mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Hapus</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="downloadPDF(item)">
                <v-list-item-icon>
                  <v-icon color="blue">mdi-file-pdf</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Unduh Laporan</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        data: {
          nomor: "",
          tahun: "",
          sekolah: ""
        },
        disabled: {},
        query: {}
      },
      sort: {
        active: false
      },
      search: {
        awaiting: false,
        data: ""
      },
      table: {
        awaiting: false
      },
      loading: false,
      options: {},
      headers: [
        {
          value: "TanggalPelaporan",
          text: "Tanggal",
          width: "10%"
        },
        {
          value: "Bulan",
          text: "Bulan",
          width: "10%"
        },
        {
          value: "Sekolah",
          text: "Sekolah",
          width: "20%"
        },
        {
          value: "Nomor",
          text: "Nomor",
          width: "10%"
        },
        {
          value: "NominalPenerimaan",
          text: "Penerimaan",
          width: "10%"
        },
        {
          value: "NominalBelanja",
          text: "Belanja",
          width: "10%"
        },
        {
          value: "LastUpdatedDate",
          text: "Terakhir Diubah",
          width: "15%"
        },
        {
          value: "Actions",
          sortable: false,
          width: "20%"
        }
      ],
      items: [],
      totalItems: 0
    };
  },

  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", ["isTahunLoading"])
  },
  methods: {
    async getItems() {
      this.loading = true;
      let payload = this.$format.payload(this.options);
      payload.Filter = this.filter.query;

      // inject sekolah
      if (this.$util.isEmpty(payload.Filter)) {
        if (this.$acl.check("isSekolah")) {
          let filter = new this.$dbflex();
          let user = this.$session.get.user();
          filter.eq("IDSekolah", user.idSekolah);
          payload.Filter = filter.get();
        }
      }

      payload.KeywordFields = [];
      payload.Keyword = this.filter.active
        ? ""
        : this.$format.keyword(this.search.data);

      if (payload.Orders.length == 0) payload.Orders = ["-LastUpdatedDate"];

      this.$axios
        .post("/report/sp2b/list", payload)
        .then(res => {
          const result = res.data;

          this.items = result.Data;
          this.totalItems = result.Total;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async downloadPDF(item) {
      this.$axios
        .get(`/report/sp2b/print/${item.IDSP2B}`)
        .then(res => {
          window.open(res.data.Data);
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        });
    },
    async editItem(item) {
      this.$router.push(`/laporan/sp2b/${item.ID}`);
    },
    async viewItem(item) {
      this.$router.push(`/laporan/sp2b/${item.ID}`);
    },
    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        item.processing = true;
        this.$axios
          .delete(`/report/sp2b/${item.IDSP2B}`)
          .then(res => {
            if (res.data.Success) {
              this.$dialog.notify.success(res.data.Message, {
                ...this.app.notification
              });
            }
            this.getItems();
          })
          .catch(error => {
            this.$dialog.notify.error(error, {
              position: this.app.notification.position
            });
          })
          .finally(() => {
            item.processing = false;
          });
      }
    },
    doFilter() {
      let filter = new this.$dbflex();
      let data = this.filter.data;

      // inject sekolah
      if (this.$acl.check("isSekolah")) {
        let user = this.$session.get.user();
        filter.eq("IDSekolah", user.idSekolah);
      }

      if (data.tahun.length > 0) {
        let filterTahun = new this.$dbflex("$or");
        data.tahun.map(v => {
          filterTahun.eq("Tahun", v);
        });
        filter.add(filterTahun.get());
      }
      if (data.sekolah.length > 0) {
        let filterSekolah = new this.$dbflex("$or");
        data.sekolah.map(v => {
          filterSekolah.eq("IDSekolah", v);
        });
        filter.add(filterSekolah.get());
      }

      let query = filter.get();
      if (query) {
        this.filter.dialog = false;
        this.filter.active = true;
        this.filter.query = query;
        this.search.data = "";
        this.getItems();
      }
    },
    resetFilter() {
      this.filter.dialog = false;
      this.$refs.form.reset();
    },
    clearFilter() {
      this.$refs.form.reset();
      this.filter.active = false;
      this.filter.query = null;
      this.search.data = "";
      this.getItems();
    },
    clearSort() {
      this.filter.sort = false;
      this.options.sortBy = [];
      this.options.sortDesc = [];
    },
    removeFilterSekolah(item) {
      const index = this.filter.data.sekolah.indexOf(item.Nama);
      if (index >= 0) this.filter.data.sekolah.splice(index, 1);
    },
    ...mapActions("list", ["refreshTahun", "refreshSekolah", "refreshPejabat"])
  },
  watch: {
    options: {
      handler(v) {
        var delay = 500;
        if (!this.table.awaiting) {
          setTimeout(() => {
            this.sort.active = v.sortBy.length > 0;
            this.getItems();
            this.table.awaiting = false;
          }, delay);
        }
        this.table.awaiting = true;
      },
      deep: true
    },
    "search.data"() {
      var delay = 1000;
      if (!this.search.awaiting) {
        setTimeout(() => {
          this.getItems();
          this.search.awaiting = false;
        }, delay);
      }
      this.search.awaiting = true;
    }
  },

  mounted() {
    this.refreshTahun();
    this.refreshSekolah();
  }
};
</script>

<style>
</style>